import { inclusiveDayDiff } from "@taabl/common-lib/calculators/date";
import {
  getMonthIntervals,
  writeToFile,
} from "@taabl/common-lib/transformers/ExpenseReport";
import { Constants } from "./Constants";
import {
  calculateEquivalentShares,
  calculateFairValue,
} from "./contributionLib";
import {
  convertCellForExcel,
  convertCellWithForumlaForExcel,
  convertDate,
  convertToDollar,
  convertUTCDateInTimeZone,
  formatDate,
  getCurrentDate,
  getDetailsFromKey,
  getNextColumnForExcel,
  incrementColumnForExcel,
} from "./utils";
const moment = require("moment");
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const TYPE_MAPPER = {
  i: "Increases",
  w: "Withdrawals",
  t: "Terminations",
};
export function exportModificationsToFile(
  rows,
  start,
  end,
  trancheList,
  activeCompany,
  totalPeriods = 1
) {
  console.log("exportModifications", rows, activeCompany, trancheList);
  let sheet_rows = [];
  let column_details = {};
  let char = "M";
  sheet_rows.push(
    {
      A: activeCompany.name,
    },
    {
      A: "ESPP Modification Charge",
    },
    {
      A: formatDate(getCurrentDate(), Constants.DATEFORMAT.DDMMMYY),
    },
    {
      A: "",
    }
  );
  let srows = [
    {
      A: "",
      B: "Employee Number",
      C: "Employee Name",
      D: "Cost Center",
      E: "Subsidiary",
      F: "New Contribution $",
      G: "Old Contribution $",
      H: "Increase",
      I: "Offering Period",
      J: "Offering Period Lookback Price",
      K: "Modification Date",
      L: "Offering Period End Date",
    },
    {
      A: "",
      B: "",
      C: "",
      D: "",
      E: "",
      F: "",
      G: "",
      H: "",
      I: "",
      J: "",
      K: "",
      L: "",
    },
  ];

  const COL_FOR_EACH_PERIOD = ["Equivalent Shares", "Grant Date Fair Value"];
  for (let col of COL_FOR_EACH_PERIOD) {
    column_details[col] = char;
    for (let i of trancheList) {
      if (i == 0) {
        srows[0][char] = col;
      } else {
        if (totalPeriods === 1) srows[0][char] = col;
        else srows[0][char] = "";
      }
      srows[1][char] = `Period ${i + 1}`;
      char = getNextColumnForExcel(char);
    }
  }
  srows[0][char] = "";
  srows[1][char] = "Total Modification Charge";
  column_details["Total Modification Charge"] = char;
  char = getNextColumnForExcel(char);

  srows[0][char] = "";
  srows[1][char] = "Remaining Service Period Days";
  column_details["Remaining Service Period Days"] = char;
  char = getNextColumnForExcel(char);

  srows[0][char] = "";
  srows[1][char] = "Expense per Day";
  column_details["Expense per Day"] = char;
  char = getNextColumnForExcel(char);

  srows[0][char] = "";
  srows[1][char] = "";
  column_details["empty"] = char;
  char = getNextColumnForExcel(char);

  srows[0][char] = "Expense";
  column_details["Expense"] = char;

  let monthsArray = getMonthIntervals(start, end, activeCompany.timezone);
  for (let month of monthsArray) {
    srows[1][char] = convertCellForExcel(
      convertUTCDateInTimeZone(
        month.lastDayofMonth,
        activeCompany.timezone
      ).format(Constants.DATEFORMAT.MMDDYYYY),
      "date"
    );
    char = getNextColumnForExcel(char);
  }

  sheet_rows.push(...srows);

  let type = "FALSE";
  for (let row of rows) {
    if (type !== row.type) {
      type = row.type;
      if (type in TYPE_MAPPER) {
        sheet_rows.push(
          {
            A: "",
          },
          {
            A: mapTypeToHeading(type),
          }
        );
      }
    }
    sheet_rows.push(
      convertModificationsForExcel(
        row,
        sheet_rows.length + 1,
        null,
        totalPeriods,
        column_details,
        trancheList,
        activeCompany.timezone
      )
    );
  }
  sheet_rows.push({
    A: "",
  });
  sheet_rows.push(
    generateTotalRow(sheet_rows, start, end, column_details, trancheList)
  );
  writeToFile(sheet_rows, "Modifications");
}
// This function is used to get the generated row and convert to xls row needed
function convertModificationsForExcel(
  row,
  rowIndex,
  totalTranche,
  totalPeriods,
  column_details,
  trancheList,
  timezone
) {
  console.log("convertRowForExcel", row);
  let newRow = {
    A: "",
    B: row.employeeNumber,
    C: row.employeeName,
    D: row.costCenter || "",
    E: row.subsidiary || "",
    F: convertCellForExcel(row.newContribution, "currency"),
    G: convertCellForExcel(row.oldContribution, "currency"),
    H: convertCellForExcel(row.increase, "currency"),
    I: "1",
    J: convertCellForExcel(row.offeringPrice, "currency"),
    K: convertCellForExcel(
      convertUTCDateInTimeZone(row.modificationDate, timezone).format(
        Constants.DATEFORMAT.MMDDYYYY
      ),
      "date"
    ),
    L: convertCellForExcel(
      convertUTCDateInTimeZone(row.offerEndDate, timezone).format(
        Constants.DATEFORMAT.MMDDYYYY
      ),
      "date"
    ),
  };
  let char = "M";
  for (let i of trancheList) {
    let key = `shares${i + 1}`;
    if (key in row && row[key]) {
      newRow[char] = Object.assign(convertCellForExcel(0, "number"), {
        f: `ROUNDDOWN(H${rowIndex}/J${rowIndex},0)`,
      });
    } else {
      newRow[char] = Object.assign(convertCellForExcel(0, "number"));
    }
    key = `value${i + 1}`;
    newRow[incrementColumnForExcel(char, totalPeriods)] = 0;
    if (key in row && row[key]) {
      newRow[incrementColumnForExcel(char, totalPeriods)] = convertCellForExcel(
        row[key],
        "currency"
      );
      console.log(
        "incrementColumnForExcel(char, totalPeriods)",
        incrementColumnForExcel(char, totalPeriods)
      );
    }
    char = getNextColumnForExcel(char);
  }
  char = incrementColumnForExcel(char, totalPeriods);
  // Total fair value
  newRow[char] = getColumnForModification(
    "totalValue",
    row,
    rowIndex,
    totalTranche,
    totalPeriods,
    column_details
  );
  char = getNextColumnForExcel(char);
  // Offering Period Days
  newRow[char] = getColumnForModification(
    "remainingDays",
    row,
    rowIndex,
    totalTranche,
    totalPeriods,
    column_details
  );
  char = getNextColumnForExcel(char);

  //Expense per Day
  newRow[char] = getColumnForModification(
    "expPerDay",
    row,
    rowIndex,
    totalTranche,
    totalPeriods,
    column_details
  );
  char = getNextColumnForExcel(char);
  let previousChar = char;
  //Empty column
  newRow[char] = getColumnForModification(
    "empty",
    row,
    rowIndex,
    totalTranche,
    totalPeriods,
    column_details
  );
  char = getNextColumnForExcel(char);
  //Move the monthValues
  if ("expenses" in row && row.expenses) {
    let excelChar = char;

    for (let i = 0; i < row.expenses.length; i++) {
      let month = row.expenses[i];
      if (totalPeriods === totalTranche) {
        // Check if value is present
        // we need to check if there is type then if this is last value
        let lastMonthIndex = -1;
        if (row.type && (row.type === "t" || row.type === "w")) {
          // Get last month index having a value
          lastMonthIndex = row.expenses.length - 1;
        }
        if (month.value) {
          if (lastMonthIndex !== -1 && lastMonthIndex === i) {
            // this might be last month of terminate or withdraw
            if (row.type && row.type === "w") {
              newRow[char] = Object.assign(convertCellForExcel(0, "currency"), {
                f: `${column_details["Total Fair Value"]}${rowIndex}-${column_details["costPerDay"]}${rowIndex}*(${excelChar}$6-${column_details["Expense"]}$6)`,
              });
            }
            if (row.type && row.type === "t") {
              newRow[char] = Object.assign(convertCellForExcel(0, "currency"), {
                // f: `-${column_details['costPerDay']}${rowIndex}*(${excelChar}$4-${column_details['Expense']}$4)`,
                f: `-SUM(${column_details["empty"]}${rowIndex}:${previousChar}${rowIndex})`,
              });
            }
          } else {
            newRow[char] = Object.assign(convertCellForExcel(0, "currency"), {
              f: `MAX(MIN(${excelChar}$6-G${rowIndex},${column_details["periodDays"]}${rowIndex}),${column_details["empty"]}${rowIndex})*${column_details["costPerDay"]}${rowIndex}-SUM(${column_details["empty"]}${rowIndex}:${previousChar}${rowIndex})`,
            });
          }
        }
      } else {
        newRow[char] = convertCellForExcel(month.value, "currency");
      }
      previousChar = getNextColumnForExcel(previousChar);
      excelChar = getNextColumnForExcel(excelChar);
      char = getNextColumnForExcel(char);
    }
  }
  return newRow;
}

function getColumnForModification(
  columnName,
  row,
  rowIndex,
  totalTranche,
  totalPeriods,
  column_details
) {
  switch (columnName) {
    case "totalValue":
      if (totalPeriods === totalTranche) {
        return convertCellWithForumlaForExcel(
          rowIndex,
          "total_fair_value",
          column_details
        );
      } else {
        return convertCellForExcel(row[columnName], "currency");
      }
      break;
    case "remainingDays":
      return Object.assign(convertCellForExcel(0, "number"), {
        f: `L${rowIndex}-K${rowIndex}`,
      });
      break;
    case "expPerDay":
      return Object.assign(convertCellForExcel(0, "currency"), {
        f: `${column_details["Total Modification Charge"]}${rowIndex}/(${column_details["Remaining Service Period Days"]}${rowIndex})`,
      });
      break;
    case "empty":
      if (totalPeriods === totalTranche) {
        return convertCellWithForumlaForExcel(
          rowIndex,
          "empty_difference",
          column_details
        );
      } else {
        return convertCellForExcel(0, "number");
      }
  }
}

function mapTypeToHeading(type) {
  if (type in TYPE_MAPPER) {
    return TYPE_MAPPER[type];
  }
  return type;
}

function generateTotalRow() {
  return {};
}

function groupModificationByUser(modifications) {
  // Let's first group contribution by user
  let modificationsByUser = {};

  for (let current of modifications) {
    let user = getDetailsFromKey(current.object_id);
    if (user in modificationsByUser) {
      modificationsByUser[user].push(current);
    } else {
      modificationsByUser[user] = [current];
    }
  }
  // Sort them by created at
  for (let key in modificationsByUser) {
    modificationsByUser[key] = modificationsByUser[key].sort(
      (a, b) => b.modificationDate - a.modificationDate
    );
  }
  return modificationsByUser;
}

export function generateJsonModification(
  modifications,
  type = null,
  totalTranche,
  offer,
  selectedPeriod,
  company
) {
  let tableRows = [];
  let modificationsByUser = groupModificationByUser(modifications);
  let users = Object.keys(modificationsByUser);
  let contributionElection = [];
  let grantFairValue = [];
  for (let i = 0; i < totalTranche; i++) {
    contributionElection[i] = 0;
    grantFairValue[i] = 0;
  }
  for (let user of users) {
    // Sort user contributions by date
    let allUserModifications = modificationsByUser[user].sort(
      (a, b) => a.modificationDate - b.modificationDate
    );

    for (let modification of allUserModifications) {
      let modificationDate = convertUTCDateInTimeZone(
        modification.modificationDate,
        company.timezone
      );
      let startingDate = null;
      // This means multiple changes like increase(s)/descrease(s) + withdraw/terminate
      if (allUserModifications.length > 1) {
        // We don't want to show withdraw/terminate separately
        if (
          type === Constants.CONTRIBUTION_STATUS.WITHDRAW ||
          type === Constants.CONTRIBUTION_STATUS.TERMINATE
        ) {
          if (modification.type === type) {
            continue;
          } else {
            if (modification.type !== Constants.CONTRIBUTION_STATUS.DECREASE) {
              startingDate = convertUTCDateInTimeZone(
                modification.modificationDate,
                company.timezone
              );
            }
            let mf = allUserModifications.filter((m) => m.type === type);
            if (mf) {
              modificationDate = mf[0].modificationDate;
            }
          }
        }
      }
      let details = modification["GSI2_sort_key"].split("|");
      let dapartment = details[2];
      let subsidiary = details[3];
      let increase =
        modification.newContribution > modification.oldContribution
          ? modification.newContribution - modification.oldContribution
          : 0;
      let empName = "";
      if (
        "firstName" in modification &&
        modification.firstName &&
        "lastName" in modification &&
        modification.lastName
      ) {
        empName = modification.firstName + " " + modification.lastName;
      }
      let newRow = {
        type:
          type !== Constants.CONTRIBUTION_STATUS.NEW
            ? type.charAt(0)
            : modification.type.charAt(0),
        employeeNumber: modification.empid || "",
        employeeName: empName || "",
        costCenter: dapartment || "",
        subsidiary: subsidiary || "",
        newContribution: convertToDollar(modification.newContribution),
        oldContribution: convertToDollar(modification.oldContribution),
        increase: convertToDollar(increase),
        offeringPeriod: "1",
        offeringPrice: convertToDollar(modification.purchasePrice),
        modificationDate: convertUTCDateInTimeZone(
          modificationDate,
          company.timezone
        ),
        offerEndDate: convertUTCDateInTimeZone(
          offer.offerEnddate,
          company.timezone
        ),
      };

      if (startingDate) {
        newRow["modificationDate"] = startingDate;
      }
      let sum = 0;
      for (let i = 1; i <= totalTranche; i++) {
        newRow[`shares${i}`] = modification.grantDateFairValue[`tranche${i}`]
          ? increase !== 0
            ? calculateEquivalentShares(increase, modification.purchasePrice)
            : 0
          : 0;
        newRow[`value${i}`] = modification.grantDateFairValue[`tranche${i}`]
          ? modification.grantDateFairValue[`tranche${i}`]
          : 0;
        sum += calculateFairValue(newRow[`shares${i}`], newRow[`value${i}`]);

        if (modification.tranche === i) {
          newRow.shares = newRow[`shares${i}`];
          newRow.value = newRow[`value${i}`];
        }
      }
      newRow.totalValue = sum;
      newRow.remainingDays = inclusiveDayDiff(
        newRow.modificationDate,
        convertUTCDateInTimeZone(newRow.offerEndDate, company.timezone)
      );
      if (startingDate) {
        newRow.remainingDays = inclusiveDayDiff(
          startingDate,
          convertUTCDateInTimeZone(newRow.offerEndDate, company.timezone)
        );
      }
      newRow.expPerDay = newRow.totalValue / newRow.remainingDays;
      let monthsArray = [];
      if (selectedPeriod.type === Constants.PERIOD_DISPLAY_TYPES.CONTRIBUTION) {
        monthsArray = getMonthIntervals(
          offer.offerStartdate,
          offer.offerEnddate,
          company.timezone
        );
      } else {
        monthsArray = getMonthIntervals(
          selectedPeriod.period.periodStartdate,
          selectedPeriod.period.periodEnddate,
          company.timezone
        );
      }
      let startedMonth = convertUTCDateInTimeZone(
        modification.modificationDate,
        company.timezone
      );
      if (startingDate)
        startedMonth = convertUTCDateInTimeZone(startingDate, company.timezone);
      let i = 0;
      let expenses = [];
      while (
        monthsArray[i] &&
        "lastDayofMonth" in monthsArray[i] &&
        convertUTCDateInTimeZone(
          monthsArray[i].lastDayofMonth,
          company.timezone
        ).isBefore(startedMonth)
      ) {
        expenses.push({
          key: convertDate(
            monthsArray[i].lastDayofMonth,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            company.timezone
          ),
          value: 0,
        });
        i++;
      }
      //let modifiedMonth = convertUTCDateInTimeZone(modification.modificationDate, company.timezone);
      let modifiedMonth = convertUTCDateInTimeZone(
        modificationDate,
        company.timezone
      );
      let sumTillNow = 0;
      let consolidatedMonth = null;
      for (let j = i; j < monthsArray.length; j++) {
        let lastDayofMonth = convertUTCDateInTimeZone(
          monthsArray[j].lastDayofMonth,
          company.timezone
        );
        if (
          type &&
          (type === Constants.CONTRIBUTION_STATUS.WITHDRAW ||
            type === Constants.CONTRIBUTION_STATUS.TERMINATE) &&
          lastDayofMonth.isSameOrAfter(modifiedMonth)
        ) {
          consolidatedMonth = j;
          break;
        }
        let days = monthsArray[j].days;
        // Check if modified happened in that month
        if (
          modifiedMonth.format("MMYYYY") === lastDayofMonth.format("MMYYYY")
        ) {
          days = inclusiveDayDiff(
            modifiedMonth,
            convertUTCDateInTimeZone(lastDayofMonth, company.timezone)
          );
        }
        if (startedMonth.format("MMYYYY") === lastDayofMonth.format("MMYYYY")) {
          days = inclusiveDayDiff(
            startedMonth,
            convertUTCDateInTimeZone(lastDayofMonth, company.timezone)
          );
        }
        expenses.push({
          key: convertDate(
            monthsArray[j].lastDayofMonth,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            company.timezone
          ),
          value: days * newRow.expPerDay,
        });
        sumTillNow += days * newRow.expPerDay;
      }
      if (
        type &&
        type === Constants.CONTRIBUTION_STATUS.WITHDRAW &&
        i < monthsArray.length
      ) {
        expenses.push({
          key: convertDate(
            monthsArray[consolidatedMonth].lastDayofMonth,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            company.timezone
          ),
          value: newRow.totalValue - sumTillNow,
        });
      }
      if (
        type &&
        type === Constants.CONTRIBUTION_STATUS.TERMINATE &&
        i < monthsArray.length
      ) {
        expenses.push({
          key: convertDate(
            monthsArray[consolidatedMonth].lastDayofMonth,
            Constants.DATEFORMAT.MMDDYYYY,
            false,
            company.timezone
          ),
          value: -sumTillNow,
        });
      }
      newRow.expenses = expenses;
      tableRows.push(newRow);
    }
  }
  return tableRows;
}

export function calculateTotalModification(records, totalTranche) {
  let totalCharge = 0;
  if (records && records.length > 0) {
    let mRows = records.filter((item) => {
      let increase =
        item.newContribution > item.oldContribution
          ? item.newContribution - item.oldContribution
          : 0;
      if (item.type && increase > 0) return item;
    });
    let increase = 0;
    let shares = 0;
    if (mRows && mRows.length > 0) {
      for (let record of mRows) {
        increase = record.newContribution - record.oldContribution;
        for (let i = 1; i <= totalTranche; i++) {
          if (`tranche${i}` in record.grantDateFairValue) {
            shares = calculateEquivalentShares(increase, record.purchasePrice);
            totalCharge += calculateFairValue(
              shares,
              record.grantDateFairValue[`tranche${i}`]
            );
          }
        }
      }
    }
  }
  return totalCharge;
}
